import React, {useEffect, useState} from "react";
import {Form} from "react-bootstrap";
import AsyncSelect from "react-select/async";

export function AGCStaticSelect({
                                    data,
                                    formik,
                                    isMulti,
                                    name,
                                    toolTip = "",
                                    value,
                                    id,
                                    forUpdate = false,
                                    required = true,
                                }) {
    const [dataList, setDataList] = useState([]);
    const [inputValue, setInputValue] = useState("");

    if (toolTip === "") {
        toolTip = "Select " + name;
    }

    if (value === null) {
        value = ""
    }

    useEffect(() => {
        setDataList(data);
    }, [data]);

    const loadOptions = (inputValue, callback) => {
        const filteredOptions = dataList.filter((option) =>
            option.name.toLowerCase().includes(inputValue.toLowerCase())
        );

        callback(filteredOptions);
    };

    return (
        <>
            <Form.Label className={required ? "required" : ""}>{name}</Form.Label>
            <AsyncSelect
                isMulti={isMulti}
                defaultOptions={dataList}
                value={value}
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.id}
                inputValue={inputValue}
                onInputChange={setInputValue}
                loadOptions={loadOptions}
                isDisabled={forUpdate}
                onChange={(option) => formik.setFieldValue(id, option)}
            />
            <Form.Text className="text-muted">{toolTip}</Form.Text>
        </>
    );
}
